import "./Account.css";
import { useContext, useEffect, useState, useRef, } from "react";
// import Button from "@mui/material/Button";
import { AppRegistration, Login, Logout, Refresh } from "@mui/icons-material";

import AppContext from "../contexts/AppContext";
import CookieContext from "../contexts/CookieContext";
import ExpTimeContext from "../contexts/ExpTimeContext";
import axios from "axios";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";

const MyPage = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm({ mode: "onChange" });

  const { apiHost, AppButton } = useContext(AppContext);

  const { cookies, setJwtCookies, refreshJwtCookies, removeJwtCookies } =
    useContext(CookieContext);

  const [axiosErr, setAxiosErr] = useState({ code: "", msg: "" });
  const { leftTime, leftTimeMs, leftTimeDhms } = useContext(ExpTimeContext);

  // ボタンの有効化/無効化の管理
  const [disabled, setDisabled] = useState(false);

  // const onDeviceRegister = async (data) => {
  const onRegister = async (data) => {

    // ボタンを無効化
    setDisabled(true);
    try {
      const res = await axios
        .post(
          // `https://api2.wacha.biz/device/register/`,
          `${apiHost}device/register/`,
          {
            // device_uuid: data.device_uuid,
            // password: data.password,
            // password: 'dummy',
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        )

        // 作成したuuidとmanagement_cdでログイン
      onLogin(res.data.uuid, res.data.management_cd);

    } catch (e) {
    } finally {
    }
  }

  const onLogin = async (uuid, management_cd) => {
    // ボタンを無効化
    setDisabled(true);
    await axios
      .post(
        // `https://api2.wacha.biz/device/token/`,
        `${apiHost}device/token/`,
        {
          // uuid: uuid,
          // password: management_cd,
          uuid: '00000000000000000000000000000000',
          password: 'takanan1',
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        setDisabled(false);
        setJwtCookies(res.data.access, res.data.refresh);
      })
      // .then(() => {
      //   // ログイン後はMyPageへ遷移
      //   (window.location.href = "/");
      // })
      .catch((err) => {
        setDisabled(false);
        if (err.response) {
          // client received an error response (5xx, 4xx)
          console.log("err.response:", err.response);
          console.log("err.response.status:", err.response.status);
          console.log("err.response.data.detail:", err.response.data.detail);

          setAxiosErr({
            ...axiosErr,
            code: err.response.status,
            msg: "ユーザ名またはパスワードが違います",
          });
        } else if (err.request) {
          // client never received a response, or request never left
          console.log("err.request:", err.request);

          setAxiosErr({
            ...axiosErr,
            code: "",
            msg: "エラーが発生しました",
          });
        } else {
          // anything else
          console.log("err:", err);

          setAxiosErr({
            ...axiosErr,
            code: "",
            msg: "エラーが発生しました",
          });
        }
      });
  };

  const onClearUuid = async () => {
    removeJwtCookies();
    // ログアウト後はHomeへ遷移
    (window.location.href = "/");
  }


  // jwtAccessの有無によって表示内容を変更
  const returnIfJwtAccessOrNot = () => {
    if (cookies.jwtAccess) {
      return (
        <>
          <div>
            {cookies.jwtAccess}
          </div>
          <div style={{ margin: "5px", fontWeight: 700, }}>
            <p id="uuid">
            {cookies.accessTokenUuid}
            </p>
            {/* <form onSubmit={handleSubmit(onClearUuid)}> */}
            <form onSubmit={handleSubmit(onLogin)}>
            {/* <form onSubmit={handleSubmit(onLogin('00000000000000000000000000000000', 'takanan1'))}> */}
              <AppButton disabled={disabled}>
                <span>ログイン</span>
              </AppButton>
            </form>
           </div>
        </>
      )
    }
    else {
      return (
        <>
          <div style={{ margin: "5px", fontWeight: 700, }}>
            <form onSubmit={handleSubmit(onLogin)}>
              {/* <input type="text" {...register('uuid', {required: '必須'})} /> */}
              <AppButton>
                <span>AAA</span>
              </AppButton>
            </form>
          </div>
        </>
      )
    }
  }

  return (
    <>
      {returnIfJwtAccessOrNot()}
      {/* <div style={{ margin: "5px", fontWeight: 700, }}>
        <form onSubmit={handleSubmit(onLogin)}>
          <AppButton disabled={disabled}>
            <span>ログイン</span>
          </AppButton>
        </form>
      </div> */}
      現在登録中のcookie
      <div style={{ margin: "5px", fontWeight: 700, }}>
        cookies.accessTokenUuid:{cookies.accessTokenUuid}<br />
        cookies.accessTokenManagementCd:{cookies.accessTokenManagementCd}<br />
      </div>
    </>
  )
}
export default MyPage